module.exports = __webpack_public_path__ + "img/znapshot.a9692156.png";